module.exports = __webpack_public_path__ + "img/brand-target.46ac4a84.png";